import Group from 'components/utils/Group'
import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'

const ImageLoadingBox = styled(LoadingBox)`
  width: ${rem(220)};
  height: ${rem(80)};
`

function MiniTileLoadingSkeleton() {
  return <Group direction="vertical" gap={8}>
    <ImageLoadingBox />
    <Group direction="vertical">
      <TextLoadingBox typography="caption-large" width="100%" />
      <TextLoadingBox typography="caption-large" width="50%" />
    </Group>
  </Group>
}

export default MiniTileLoadingSkeleton
